import { createTheme, GlobalStylesProps } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0f6ea2",
      light: "#62b4de",
      dark: "#0f6ea2",
    },
    secondary: {
      main: "#fd8b25",
      contrastText: "#ffffff",
      light: "#fd8b25",
      dark: "#fd8b25",
    },
  },
  shape: {
    borderRadius: 20,
  },
  components: {
    MuiPaper: {
      defaultProps: {
        elevation: 3,
      },
    },
    MuiFormControl: {
      defaultProps: {
        variant: "filled",
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: "filled",
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "filled",
        fullWidth: true,
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: "0!important",
          backgroundColor: "transparent!important",
          "&.Mui-focused .Mui-Select": {
            backgroundColor: "transparent!important",
          },
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: "lowercase",
        },
        text: {
          ".MuiButton-startIcon": {
            marginLeft: 5,
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          height: 4,
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "inherit",
          fontSize: 14,
          // ".MuiChip-root": {
          //   color: "#ffffff",
          // },
          "&.Mui-selected": {
            color: "#fd8b25",
          },
        },
      },
    },
  },
});

export const globalStyles: GlobalStylesProps["styles"] = {
  "*": {
    margin: 0,
    padding: 0,
  },
};

export default theme;
